import Loader from "components/Common/loader"
import { Card, CardBody, CardFooter } from "reactstrap"
import { MdDelete } from "react-icons/md"
import { useDispatch, useSelector } from "react-redux"
import {
  allApplications,
  DeleteMiscellaneousDoc,
} from "redux/slice/applications/applicationSlice"
import fileImage from "../../assets/images/fileimage.png"
import { useEffect, useState } from "react"
import { getUserTokenRole } from "utilities/parse-jwt"

export default function MiscDocs(props) {
  let dispatch = useDispatch()
  const [role, setRole] = useState("")
  const { miscellaneousDocs, currentApplicationSelected, loading } =
    useSelector(allApplications)
    
  const findUserRole = async () => {
    let usertokenRole = await getUserTokenRole()
    console.log("Role detected: ", usertokenRole)
    setRole(usertokenRole)
  }
  useEffect(() => {
    findUserRole();
  }, [])

  const handleDeleteMiscDoc = doc_id => {
    // misc docs
    let data = {
      studentId: currentApplicationSelected?.id,
      documentId: doc_id,
    }
    console.log("data to delete misc", data)
    dispatch(DeleteMiscellaneousDoc(data))
  }

  return (
    <div>
      <Card className="bg-white">
        <CardBody className="mt-2">
          {loading ? (
            <Loader />
          ) : (
            <>
              <h5
                className="mb-2 text-secondary-si"
                style={{ fontWeight: "normal" }}
              >
                Miscellaneous Documents
              </h5>
              {miscellaneousDocs && miscellaneousDocs.length > 0
                ? miscellaneousDocs?.map((item, index) => (
                    <div className="" key={index}>
                      <h6 className="mt-3 text-secondary-si">
                        Year {item?.year} Documents
                      </h6>
                      <div className="row">
                        {item?.documentUrls && item?.documentUrls?.length > 0
                          ? item?.documentUrls?.map((image, index) => (
                              <div
                                className="col-6 col-md-3 col-lg-2 d-flex justify-content-center mb-3"
                                key={index}
                                onClick={() =>
                                  window.open(image?.documentUrl, "_blank")
                                }
                              >
                                <div
                                  className="text-center position-relative"
                                  style={{ cursor: "pointer" }}
                                >
                                  {/* <a onClick={() => window.open(image, "_blank")}> */}
                                  <img
                                    src={fileImage}
                                    alt={`Year ${item?.year} Document`}
                                    className="img-thumbnail"
                                    style={{
                                      maxWidth: "100px",
                                      maxHeight: "100px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  <p
                                    className="text-truncate text-wrap"
                                    style={{
                                      maxWidth: "100px",
                                      marginBottom: "30px",
                                    }}
                                  >
                                    {image?.documentType
                                      ? image?.documentType
                                      : "Other"}
                                  </p>
                                  {/* </a> */}
                                  {role === "Admin" && (
                                    <button
                                      className="btn btn-danger btn-sm w-100 position-absolute start-0 bottom-0 mt-5"
                                      onClick={e => {
                                        e.stopPropagation()
                                        handleDeleteMiscDoc(image?.id)
                                      }}
                                    >
                                      <MdDelete />
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))
                          : null}
                      </div>
                    </div>
                  ))
                : null}
            </>
          )}
        </CardBody>
        <CardFooter>
          <div className="mt-4 float-end">
            <button
              className="btn btn-danger"
              onClick={() => {
                props?.close()
              }}
            >
              Close
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
}
